<template>
  <div id="printable">
    <v-table
      :row-active-id="rowActiveId"
      :data="tableData"
      :columns="columns"
      clickable
      @row-click="onRowClick"
    >
      <template v-slot:column-time="item">
        <p
          v-if="item.row.isNew"
          :class="$style.new"
        >
          NEW
        </p>
        {{ item.row.date | dateTime }}
      </template>
      <template v-slot:column-url="item">
        <span :class="$style.dangerous">
          <dangerous :value="item.row.statusDangerous" />
        </span>
        {{ item.row.url }}
      </template>
    </v-table>
    <additional-list-attachments
      v-if="rowActiveId"
      :list="additionalList"
      :attachments="additionalAttachments"
      log="file-upload"
    />
  </div>
</template>

<script>
  import VTable from '@/components/common/table/table.vue';
  import Dangerous from '@/components/common/dangerous/index.vue';
  import AdditionalListAttachments from '@/components/common/logs/additional/list-attachments/index.vue';
  import { dateTime } from '@/helpers/filters';
  import { LogData } from '@/domains/log/data';

  export default {
    components: {
      VTable,
      Dangerous,
      AdditionalListAttachments,
    },
    filters: {
      dateTime,
    },
    props: {
      data: {
        type: null,
        required: true,
      },
    },
    data() {
      return {
        columns: [
          {
            field: 'time',
            title: this.$t('pages.columns.time'),
            sortFn: (isAsc) => (a, b) => (new Date(a.date) - new Date(b.date)) * (isAsc ? 1 : -1),
          },
          { field: 'url', title: this.$t('pages.columns.link') },
          { field: 'username', title: this.$t('pages.columns.username') },
        ],
      };
    },
    computed: {
      rowActiveId() {
        return parseInt(this.$route.params.record, 10);
      },
      tableData() {
        return LogData.filterTable(
          this.data,
          [(item) => dateTime(item.date), 'url', 'host', 'username'],
          this.$route.query.filter,
        );
      },
      activeRow() {
        const activeRow = this.data.find((i) => i?.id === this.rowActiveId);

        return activeRow || {};
      },
      additionalList() {
        const row = this.activeRow;

        return [
          [this.$t('pages.columns.time'), dateTime(row.date)],
          [this.$t('pages.columns.link'), row.url],
          [this.$t('pages.columns.server'), row.host],
          [this.$t('pages.columns.username'), row.username],
        ];
      },
      additionalAttachments() {
        const row = this.activeRow;

        return row.attachments.map((attachment) => ({
          id: attachment.id,
          filename: attachment.filename,
          size: attachment.size,
          url: this.$route.params.computer,
          record: this.$route.params.record,
        }));
      },
    },
    created() {
      this.$store.commit('logs/printData/setColumns', this.columns);
    },
    methods: {
      onRowClick(id) {
        this.$router.push({
          name: 'computers-computer-log-record',
          params: { record: id },
          query: this.$route.query,
        });
      },
    },
  };
</script>

<style lang="scss" module>
  .new {
    display: inline-block;
    background: $light-blue;
    color: $blue;
    font-size: 7px;
    padding: 3px;
    margin-right: 8px;
    border-radius: 1px;
  }

  .dangerous {
    display: inline-block;
    margin-right: 8px;
  }
</style>
